import { render, staticRenderFns } from "./LoadingService.vue?vue&type=template&id=465def4e&"
import script from "./LoadingService.vue?vue&type=script&lang=js&"
export * from "./LoadingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports